import { AddressTypes } from "./AddressTypeButton";
interface Props {
  svgType: AddressTypes;
}

const SvgAddressType: React.FC<Props> = ({ svgType }) => {
  return (
    <div>
      {svgType === AddressTypes.home ? (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_14206_9001)">
            <path
              d="M5.98779 1.00018C5.90783 1.00291 5.83084 1.03114 5.76807 1.08075L2.21484 3.88006C1.76387 4.23547 1.5 4.77856 1.5 5.35272V10.1252C1.5 10.4661 1.7841 10.7502 2.125 10.7502H4.625C4.9659 10.7502 5.25 10.4661 5.25 10.1252V7.62518C5.25 7.55142 5.30124 7.50018 5.375 7.50018H6.625C6.69876 7.50018 6.75 7.55142 6.75 7.62518V10.1252C6.75 10.4661 7.0341 10.7502 7.375 10.7502H9.875C10.2159 10.7502 10.5 10.4661 10.5 10.1252V5.35272C10.5 4.77856 10.2361 4.23547 9.78516 3.88006L6.23193 1.08075C6.16259 1.02597 6.07612 0.997434 5.98779 1.00018ZM6 1.85272L9.32129 4.46942C9.59231 4.68301 9.75 5.00788 9.75 5.35272V10.0002H7.5V7.62518C7.5 7.14644 7.10374 6.75018 6.625 6.75018H5.375C4.89626 6.75018 4.5 7.14644 4.5 7.62518V10.0002H2.25V5.35272C2.25 5.00788 2.40769 4.68301 2.67871 4.46942L6 1.85272Z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id="clip0_14206_9001">
              <rect width="12" height="12" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ) : svgType === AddressTypes.work ? (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_14206_8345)">
            <path
              d="M4.625 1.5C4.14626 1.5 3.75 1.89626 3.75 2.375V3H1.875C1.39626 3 1 3.39626 1 3.875V9.875C1 10.3537 1.39626 10.75 1.875 10.75H10.125C10.6037 10.75 11 10.3537 11 9.875V3.875C11 3.39626 10.6037 3 10.125 3H8.25V2.375C8.25 1.89626 7.85374 1.5 7.375 1.5H4.625ZM4.625 2.25H7.375C7.44876 2.25 7.5 2.30124 7.5 2.375V3H4.5V2.375C4.5 2.30124 4.55124 2.25 4.625 2.25ZM1.875 3.75H10.125C10.1988 3.75 10.25 3.80124 10.25 3.875V7.25H6.75V7.125C6.75 6.918 6.582 6.75 6.375 6.75H5.625C5.418 6.75 5.25 6.918 5.25 7.125V7.25H1.75V3.875C1.75 3.80124 1.80124 3.75 1.875 3.75ZM1.75 8H5.25V8.125C5.25 8.332 5.418 8.5 5.625 8.5H6.375C6.582 8.5 6.75 8.332 6.75 8.125V8H10.25V9.875C10.25 9.94876 10.1988 10 10.125 10H1.875C1.80124 10 1.75 9.94876 1.75 9.875V8Z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id="clip0_14206_8345">
              <rect width="12" height="12" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ) : (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clipPath="url(#clip0_14206_8349)">
            <path
              d="M6 1C3.65731 1 1.75 2.90731 1.75 5.25C1.75 6.3017 2.13583 7.26621 2.76953 8.00781L2.77148 8.00977L2.77295 8.01172C2.77295 8.01172 4.58093 10.0748 5.22461 10.689C5.65564 11.0999 6.34387 11.0999 6.7749 10.689C7.5086 9.98917 9.22754 8.01074 9.22754 8.01074L9.22852 8.00928L9.22998 8.00781C9.86425 7.2662 10.25 6.3017 10.25 5.25C10.25 2.90731 8.34269 1 6 1ZM6 1.75C7.93731 1.75 9.5 3.31269 9.5 5.25C9.5 6.1188 9.18339 6.90815 8.65967 7.52051C8.65626 7.52441 6.89751 9.53588 6.25732 10.1465C6.10886 10.288 5.89065 10.288 5.74219 10.1465C5.20714 9.63594 3.34527 7.52666 3.33984 7.52051L3.33936 7.52002C2.81633 6.90771 2.5 6.11856 2.5 5.25C2.5 3.31269 4.06269 1.75 6 1.75ZM6 3.75C5.53125 3.75 5.1322 3.93928 4.87598 4.22754C4.61975 4.51579 4.5 4.88542 4.5 5.25C4.5 5.61458 4.61975 5.98421 4.87598 6.27246C5.1322 6.56072 5.53125 6.75 6 6.75C6.46875 6.75 6.8678 6.56072 7.12402 6.27246C7.38025 5.98421 7.5 5.61458 7.5 5.25C7.5 4.88542 7.38025 4.51579 7.12402 4.22754C6.8678 3.93928 6.46875 3.75 6 3.75ZM6 4.5C6.28125 4.5 6.4447 4.59197 6.56348 4.72559C6.68225 4.85921 6.75 5.05208 6.75 5.25C6.75 5.44792 6.68225 5.64079 6.56348 5.77441C6.4447 5.90803 6.28125 6 6 6C5.71875 6 5.5553 5.90803 5.43652 5.77441C5.31775 5.64079 5.25 5.44792 5.25 5.25C5.25 5.05208 5.31775 4.85921 5.43652 4.72559C5.5553 4.59197 5.71875 4.5 6 4.5Z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id="clip0_14206_8349">
              <rect width="12" height="12" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )}
    </div>
  );
};

export default SvgAddressType;
